import { render, staticRenderFns } from "./EmployeePowerOfAttorneyForm.vue?vue&type=template&id=81dad044&"
import script from "./EmployeePowerOfAttorneyForm.vue?vue&type=script&lang=js&"
export * from "./EmployeePowerOfAttorneyForm.vue?vue&type=script&lang=js&"
import style0 from "./EmployeePowerOfAttorneyForm.vue?vue&type=style&index=0&id=81dad044&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports